import imgs from "../assets/imgs";

export const products = [
  {
    id: 1,
    name: "Sika 1",
    description: "Hidrófugo químico inorgánico",
    category: "Complemento para obras Húmedas",
    price: 45,
    img: imgs.SIKATEX,
  },
  {
    id: 2,
    name: "RAP 920",
    description: "Membrana líquida impermeabilizante para techos",
    category: "Cubiertas y aislaciones",
    price: 67,
    img: imgs.RAP720,
  },
  {
    id: 3,
    name: "RAP 720",
    description: "Sellador elástico acrílico impermeable para grietas",
    category: "Complemento para obras Húmedas",
    price: 23,
    img: imgs.RAP720,
  },
  {
    id: 4,
    name: "SIKALASTIC 560",
    description: "Membrana líquida impermeabilizante con poliuretano",
    category: "Complemento para obras Húmedas",
    price: 55,
    img: imgs.SIKALASTIC560,
  },
  {
    id: 5,
    name: "INERTOLTECH",
    description: "Emulsión asfáltica multiuso",
    category: "Complemento para obras Húmedas",
    price: 78,
    img: imgs.INERTOLTECH,
  },
  {
    id: 6,
    name: "SIKA TEX",
    description: "Malla para reforzar membrana líquida",
    category: "Complemento para obras Húmedas",
    price: 34,
    img: imgs.SIKATEX,
  },
  {
    id: 7,
    name: "CHAPA",
    description: "Acanalada C-25",
    category: "Complemento para obras Húmedas",
    price: 89,
    img: imgs.CHAPA,
  },
  {
    id: 8,
    name: "CHAPA TRASLÚCIDA",
    description: "Acanalada",
    category: "Cubiertas y aislaciones",
    price: 12,
    img: imgs.CHAPATRASLÚCIDA,
  },
  {
    id: 9,
    name: "ROLAC PLATA",
    description: "Aislante de lana de vidrio",
    category: "Cubiertas y aislaciones",
    price: 56,
    img: imgs.ROLACPLATA,
  },
  {
    id: 10,
    name: "ROLAC PLATA",
    description: "Aislante de lana de vidrio",
    category: "Cubiertas y aislaciones",
    price: 34,
    img: imgs.ROLACPLATA,
  },
  {
    id: 11,
    name: "EPS ACANALDO",
    description: "Aislante de telgopor para chapa acanalada",
    category: "Cubiertas y aislaciones",
    price: 78,
    img: imgs.EPSACANALDO,
  },
  {
    id: 12,
    name: "RED DE SOSTÉN",
    description: "Malla de sujeción para aislaciones de cubierta",
    category: "Complemento para obras Húmedas",
    price: 45,
    img: imgs.REDDESOSTÉN,
  },
  {
    id: 13,
    name: "LADRILLO EPS",
    description: "Ladrillo de telgopor para losas",
    category: "Complemento para obras Húmedas",
    price: 67,
    img: imgs.LADRILLOEPS,
  },
  {
    id: 14,
    name: "THERMOESPUMA",
    description: "Aislante térmico e hidrófugo de espuma de polietileno",
    category: "Complemento para obras Húmedas",
    price: 23,
    img: imgs.THERMOESPUMA,
  },
  {
    id: 15,
    name: "TAPUME",
    description: "Tablero OSB multiuso",
    category: "Obras en general",
    price: 55,
    img: imgs.TAPUME,
  },
  {
    id: 16,
    name: "ECOFORM",
    description: "Tablero OSB multiuso para molde o formas de concreto",
    category: "Obras en general",
    price: 78,
    img: imgs.ECOFORM,
  },
  {
    id: 17,
    name: "CAÑO ESTRUCTURAL",
    description: "Circular, cuadrado y rectangular",
    category: "Obras en general",
    price: 34,
    img: imgs.CAÑOESTRUCTURAL,
  },
  {
    id: 18,
    name: "CORREAS",
    description: "Distintas medidas",
    category: "Obras en general",
    price: 89,
    img: imgs.CORREAS,
  },
  {
    id: 19,
    name: "ANCLAJES QUÍMICOS",
    description: "Distintas medidas",
    category: "Obras en general",
    price: 12,
    img: imgs.ANCLAJESQUÍMICOS,
  },
  {
    id: 20,
    name: "SIKA CERAM IMPERMEABLE",
    description: "Adhesivo cementício impermeable",
    category: "Pegamentos",
    price: 56,
    img: imgs.SIKACERAMIMPERMEABLE,
  },
  {
    id: 21,
    name: "SIKA CERAM PORCELANATO",
    description: "Para pisos y revestimientos de baja absorción.",
    category: "Pegamentos",
    price: 34,
    img: imgs.SIKACERAMPORCELANATO,
  },
  {
    id: 22,
    name: "SIKA CERAM FLEXIBLE",
    description:
      "Adhesivo cementício ﬂexible, para pisos cerámicos y revestimientos.",
    category: "Pegamentos",
    price: 78,
    img: imgs.SIKACERAMFLEXIBLE,
  },
  {
    id: 23,
    name: "SIKA BINDA FIX",
    description:
      "Mezcla adhesiva cementícia impermeable, se utiliza para la colocación de cerámicos y revestimientos en pisos y paredes.",
    category: "Pegamentos",
    price: 45,
    img: imgs.SIKABINDAFIX,
  },
  {
    id: 24,
    name: "ITALFLEX",
    description: "Revestimiento acrílico texturable de base acuosa",
    category: "Pinturas y complementos",
    price: 67,
    img: imgs.ITALFLEX,
  },
  {
    id: 25,
    name: "FONDOFLEX",
    description:
      "Fondo para la aplicación de revestimientos acrílicos texturados",
    category: "Pinturas y complementos",
    price: 23,
    img: imgs.FONDOFLEX,
  },
  {
    id: 26,
    name: "PRADERA LÁTEX INTERIOR",
    description:
      "Acrílico de base acuosa, para proteger y decorar paredes interiores",
    category: "Pinturas y complementos",
    price: 55,
    img: imgs.PRADERALÁTEXINTERIOR,
  },
  {
    id: 27,
    name: "BASECOAT",
    description: "Producto cementicio modiﬁcado para nivelar superﬁcies",
    category: "Pinturas y complementos",
    price: 78,
    img: imgs.BASECOAT,
  },
  {
    id: 28,
    name: "MALLA FIBRA DE VIDRIO",
    description:
      "Para revestimiento de pared antihumedad, sistema de aislamiento térmico, revoque grueso y ﬁno, pisos y micropisos, juntas e impermeabilizaciones.",
    category: "Pinturas y complementos",
    price: 34,
    img: imgs.MALLAFIBRADEVIDRIO,
  },
];

console.log(products);

export function getAllProducts() {
  return products
}

export function getProduct(id) {
  return products.find((product) => product.id === id)
}

export function deleteProduct(id) {
  products = products.find((product) => product.id !== id)
}
